<template>
  <div class="campaign-form-container">
    <v-container>
      <v-layout row class="padding">
        <v-flex xs4 sm12 offset-sm3>
          <v-card
            class="mx-auto mt-4 pa-5 text-center text-no-wrap"
            max-width="1000"
            id="limited-products"
          >
            <v-col class="col-lg-1"  style="float:right">
            	<div class="compaign-container">
	                <v-btn class="warning" @click="back">Back</v-btn>
	            </div> 
            </v-col>
            <v-col class="col-lg-4">
            	<h2>Non Life Insurance Policy List</h2> 
            </v-col> 

            
            <v-data-table
              :headers="headers"
              :items="portfolio_aif_items"
              :search="search"
              sort-by="calories"
              class="elevation-1"
            >
             <!-- <template  v-slot:[`item.portfolio_type`]="{ item,index }"
             >
	              {{portfolio_type_list}}
	               
                </template> -->
                <template v-slot:top>
	                <v-toolbar flat>
	                  <div class="col-md-3 col-6">
	                    <v-text-field
	                      v-model="search"
	                      append-icon="mdi-magnify"
	                      label="Search"
	                      outlined
	                      dense
	                      hide-details
	                    ></v-text-field>
	                  </div>
	                  <v-spacer></v-spacer>
	                  <div class="compaign-container">
	                    <v-btn class="campaign-btn" @click="importDialog"
	                      >Import</v-btn
	                    >
	                  </div>
                </v-toolbar>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
	              	<v-icon small class="mr-2" @click="editItem(item)" title="Edit Item">
	                  mdi-pencil
	                </v-icon>|
	                <v-icon small class="mr-2" @click="deleteItem(item)" title="Delete Item">
	                  mdi-delete
	                </v-icon>
                </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="formDialog" width="900">
	    <v-card class="term-modal">
	      <v-card-title class="text-h5">
	        Edit Policy
	        <v-card-actions class="close-icon">
	          <v-btn color="primary" text @click="dialogSecond = false">
	            <v-img max-height="23" max-width="19" :src="delete_pic" :lazy-src="delete_pic"> </v-img>
	          </v-btn>
	        </v-card-actions>
	      </v-card-title>
	      <v-card-text style="margin-top:10px">
	          <v-form
	            ref="editForm"
	            v-model="valid"
	            @submit.prevent="editForm"
	            lazy-validation
	          >  
                	

	            <v-text-field
	              v-model="policy_name"
	              :rules="[v => !!v || 'Item is required']"
	              label="Enter Policy Name"
	              name="policy_name"
	              id="policy_name"
	            ></v-text-field>

	            <v-text-field
	              v-model="type"
	              :rules="[v => !!v || 'Item is required']"
	              label="Enter Type"
	              name="type"
	              id="type"
	            ></v-text-field>


	            <v-text-field
	              v-model="policy_type"
	              :rules="[v => !!v || 'Item is required']"
	              label="Enter Policr Type"
	              name="policy_type"
	              id="policy_type"
	            ></v-text-field>

	            <v-btn
	              :disabled="!valid"
	              color="warning"
	              class="mr-4"
	              type="submit"
	            >
	              Update
	            </v-btn>
	          </v-form>   
	      </v-card-text>
	    </v-card>
	  </v-dialog>
	<v-dialog v-model="importFormDialog" width="900">
		    <v-card class="term-modal">
	      <v-card-title class="text-h5">
          Import Group Insurance Policy
	        &nbsp;&nbsp;&nbsp;
            <v-btn class="success" @click="downloadSample" style="height:19px !important;">Download Sample</v-btn>
	        <v-card-actions class="close-icon">
	          <v-btn color="primary" text @click="dialogSecond = false">
	            <v-img max-height="23" max-width="19" :src="delete_pic" :lazy-src="delete_pic"> </v-img>
	          </v-btn>
	        </v-card-actions>
	      </v-card-title>
	      <v-card-text style="margin-top:10px">
	          <v-form
	            ref="submitForm"
	            v-model="valid"
	            @submit.prevent="submitForm"
	            lazy-validation
	          >  
	            <div class="col-lg-4">
	            	<v-select
		              v-model="insurance_type"
		              :items="insurance_type_items"
		              item-value="id"
		              item-text="name"
		              name = "insurance_type"
		              id   = "insurance_type"
		              label="Select Insurance Type"
		              outlined
	                  color="blue"
	                 
		              required
			        ></v-select>
	            </div>	
                <div class="col-lg-4">
                  <v-file-input
                    accept="text/csv"
                    
                    name="file"
                    id="file"
                    small-chips
                    multiple
                    label="Choose File"
                    outlined
                    color="blue"
                  ></v-file-input>
                </div>
	            <v-btn
	              :disabled="!valid"
	              color="warning"
	              class="mr-4"
	              type="submit"
	            >
	              Import
	            </v-btn>
	          </v-form>   
	      </v-card-text>
	    </v-card>
		</v-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    search: '',
    file:'',
    delete_pic:'',
    formDialog:false,
    portfolio_type_list:[],
    aif_name:'',
    valid: false,
    portfolio_name:'',
    referral_code:'',
    registration_no:'',
    portfolio_type_id:'',
    importFormDialog:false,
    headers: [
      { text: "Insurnce Type", value: "child_subcategory_name" },
      { text: "Company Name", value: "name" },
      { text: "Policy Name", value: "policy_name" },
      { text: "Type", value: "type" },
      { text: "Policy Type", value: "policy_type" },
      { text: "Actions", value: "actions", sortable: true },
    ],
    portfolio_aif_items: [],
    all_portfolio_aif_items: [],
    item_id:'',
    type:'',
    policy_type:'',
    policy_name:'',
    insurance_type:'',
    insurance_type_items:[]

  }),

  created() {
    this.initialize();
  },
  mounted() {},

  watch: {
    referral_code(val){
      this.referral_code = val.toUpperCase();
    }  
  },

  methods: {
  	 importDialog(){
    	this.importFormDialog = true
    },
    initialize() {
        let token = localStorage.getItem("token");
        axios.get(process.env.VUE_APP_ROOT_API + "admin/non-life-insurance-policy-list", {
          headers: {
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          this.portfolio_aif_items = this.all_portfolio_aif_items = response.data.data;
          this.insurance_type_items = response.data.insurance_type_list;
        });
    },

    deleteItem(item) {
      swal.fire({
        title: '',
        text: "Are You Sure You Want to Delete This Item?", 
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#051d42',
        confirmButtonText: 'OK',
      }).then((result) => {
        if (result.isConfirmed) {
            let cognito_idp = atob(localStorage.getItem('cognito_idp'));
            let formdata    = new FormData();
            formdata.append("id", item.id);
            axios.post( process.env.VUE_APP_ROOT_API+'delete-non-life-insurance-policy',
              formdata,{
	            headers: {
	                'Access-Control-Allow-Origin':'*'
	            }
	          }
	        ).then((response) => { 
	            this.portfolio_aif_items  = this.all_portfolio_aif_items =  response.data.data;
	            swal.fire({
	              title: '',
	              text: "Data Deleted Successfully",
	              icon: 'success',
	              showCancelButton: false,
	              confirmButtonColor: '#051d42',
	              confirmButtonText: 'OK',
	            }).then((result) => {
	              if (result.isConfirmed) {
	                  
	              }
	            })
	            this.$loading(false)    
	        }).catch(() => {this.$loading(false) }); 
        }
      })
     
    },

    addReferralCode(){
        this.formDialog = true
    },

    editItem(item){
        this.policy_name = item.policy_name
        this.type   = item.type
        this.policy_type  = item.policy_type
        this.item_id           = item.id
        this.formDialog        = true
    },
    submitForm(){
        if(this.$refs.submitForm.validate() !=false){
          this.$loading(true)
          let cognito_idp = atob(localStorage.getItem('cognito_idp'));
          let formdata    = new FormData();
          formdata.append("file", document.getElementById("file").files[0]);
          formdata.append("insurance_type", this.insurance_type);
          axios.post( process.env.VUE_APP_ROOT_API+'add-non-life-insurance-policy',
              formdata,{
              headers: {
                'Access-Control-Allow-Origin':'*'
              }
            }
          ).then((response) => { 
            this.portfolio_aif_items = this.all_portfolio_aif_items = response.data.data;
            swal.fire({
              title: '',
              text: "Data Updated Successfully",
              icon: 'success',
              showCancelButton: false,
              confirmButtonColor: '#051d42',
              confirmButtonText: 'OK',
            }).then((result) => {
              if (result.isConfirmed) {
                this.importFormDialog = false
              }
            })
            this.$loading(false)   
          }).catch(() => {this.$loading(false) }); 
        }
    },

    filterData(e){
    	this.portfolio_aif_items = []
        this.all_portfolio_aif_items.forEach(item => {
        	if(item.portfolio_name == e){
               this.portfolio_aif_items.push(item);
        	}
        });
    },

    editForm(){
        if(this.$refs.editForm.validate() !=false){
          this.$loading(true)
          let cognito_idp = atob(localStorage.getItem('cognito_idp'));
          let formdata    = new FormData();
          formdata.append("policy_name", this.policy_name);
          formdata.append("type", this.type);
          formdata.append("policy_type", this.policy_type);
          formdata.append("item_id",this.item_id);
          axios.post( process.env.VUE_APP_ROOT_API+'edit-non-life-insurance-policy',
              formdata,{
              headers: {
                'Access-Control-Allow-Origin':'*'
              }
            }
          ).then((response) => { 
            this.portfolio_aif_items = this.all_portfolio_aif_items = response.data.data;
            swal.fire({
              title: '',
              text: "Data Updated Successfully",
              icon: 'success',
              showCancelButton: false,
              confirmButtonColor: '#051d42',
              confirmButtonText: 'OK',
            }).then((result) => {
              if (result.isConfirmed) {
                this.formDialog = false
              }
            })
            this.$loading(false)   
          }).catch(() => {this.$loading(false) }); 
        }
    },

    back(){
        this.$router.push({
          name: 'MasterIndex',
          params: {},
        });
    },

    submitUploadFileForm(){

    },
    downloadSample(){
      let formdata    = new FormData();
      formdata.append("type", 'non_life_insurance_policy');
      axios.post( process.env.VUE_APP_ROOT_API+'download-sample-file',
        formdata,{
          headers: {
            'Access-Control-Allow-Origin':'*'
          },
          responseType: 'blob',
        },
      ).then((response) => { 
        const url = URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          `non_life_insurance_policy_sample.csv`
        )
        document.body.appendChild(link)
        link.click()
         
      }).catch(() => {this.$loading(false) }); 
    }

  },
};
</script>
<style>
	.compaign-container {
	  margin-top: 0px;
	  float: left;
	}
	.active-class {
	  color: rgb(35, 199, 35);
	  font-size: 16px;
	  font-weight: bold;
	}
	.inactive-class {
	  font-size: 16px;
	  font-weight: bold;
	  color: dimgrey;
	}


</style>
